import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accept", "changeLabel", "id", "onChange", "onClick", "selectLabel", "showFilePreview", "use", "value"],
  _excluded2 = ["display"];
import memoize from 'react-utils/memoize';
import styled from 'foundations-theming/utils';
import { Flex } from '../../../components/Flex/Flex';
import { Button } from '../Button/Button';
import { syntheticEvent } from '../../utils/SyntheticEvent/SyntheticEvent';
import { filterProps } from '../../../utils/filterProps';
import { Controllable } from '../Controllable';
import I18n from 'I18n';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilePreviewLabel = styled.label.withConfig({
  displayName: "FileInput__FilePreviewLabel",
  componentId: "cca9yg-0"
})(({
  theme
}) => {
  return {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.space['200']
  };
});
const getSuccessIcon = memoize(() => /*#__PURE__*/_jsx(SuccessIcon, {
  size: "100",
  color: "icon-core-on-fill-default"
}));
const getIconCircle = memoize(() => /*#__PURE__*/_jsx(Flex, {
  backgroundColor: "fill-positive-default",
  borderRadius: "full",
  padding: "100",
  marginInline: "200",
  children: getSuccessIcon()
}));
const HiddenInput = styled.input.withConfig({
  displayName: "FileInput__HiddenInput",
  componentId: "cca9yg-1"
})(["display:none;visibility:hidden;"]);
const InternalFileInput = _ref => {
  let {
      accept,
      changeLabel = I18n.text('salesUI.UIFileInput.defaultChangeLabel'),
      id = `file-input-${Math.random()}`,
      onChange,
      onClick,
      selectLabel = I18n.text('salesUI.UIFileInput.defaultSelectLabel'),
      showFilePreview = true,
      use = 'tertiary-light',
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  let inputEl;
  const handleClick = () => {
    if (inputEl) inputEl.click();
    if (onClick) onClick();
  };
  const handleFileSelect = evt => {
    if (onChange) onChange(syntheticEvent(evt.target.files[0], evt));
  };
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const flexStyleProps = _objectWithoutPropertiesLoose(tokenProps, _excluded2);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({}, flexStyleProps, {
    children: [/*#__PURE__*/_jsx(Button, {
      use: use,
      onClick: handleClick,
      children: value ? changeLabel : selectLabel
    }), showFilePreview && value && /*#__PURE__*/_jsxs(FilePreviewLabel, {
      htmlFor: id,
      children: [getIconCircle(), ' ',
      //@ts-expect-error keep runtime logic from UIComponents
      value.name]
    }), /*#__PURE__*/_jsx(HiddenInput, Object.assign({}, domProps, {
      accept: accept ? accept.join(',') : undefined,
      className: "hidden",
      id: id,
      onChange: handleFileSelect,
      ref: ref => {
        inputEl = ref;
      },
      type: "file"
    }))]
  }));
};
export const UncontrolledFileInput = InternalFileInput;
export const FileInput = Controllable(InternalFileInput);
FileInput.displayName = 'FileInput';